<script>
  import { createEventDispatcher } from 'svelte';
  import Button from '@components/Button.svelte';
  import Textarea from '@components/Textarea.svelte';

  const dispatch = createEventDispatcher();

  export let mobile = false;
  export let selectedQuestion = { value: '' };
  $: question = selectedQuestion.value;
</script>

<style style="text/scss" lang="scss">
  .creator-spotlight-questions {
    .ui-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 24px;
      gap: 16px;
    }
    .ui-title {
      font-weight: 500;
      font-size: 18px;
      line-height: 22px;
      max-width: 350px;
    }
    .ui-subtitle {
      margin-bottom: 16px;
      color: #717171;
    }
    .ui-back,
    .ui-close {
      background-color: transparent;
      border: none;
      margin: 0;
      padding: 0;
      opacity: 0.5;

      &:hover {
        opacity: 1;
      }
    }
  }

  .answer-form {
    margin-bottom: 16px;
    .selected-question-container {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 14px 16px;
      border: 1px solid #e3e3e3;
      border-radius: 12px;
      font-weight: 500;
      margin-bottom: 24px;
    }

    .back-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 30px;
      height: 30px;
      border-radius: 999px;
      transition: 200ms;
      cursor: pointer;

      &:hover {
        background: #f1f1f1;
      }
    }
  }
</style>

<div class="creator-spotlight-questions" class:mobile={mobile}>
  <div class="ui-header">
    <button
      class="ui-back"
      on:click={() => {
        dispatch('back');
      }}>
      <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.85501 7.26609L10.5901 1.49831L11.6538 2.55596L5.91867 8.32373C5.82171 8.42125 5.82171 8.57877 5.91867 8.67628L11.6538 14.4441L10.5901 15.5017L4.85501 9.73393C4.17626 9.05132 4.17626 7.94869 4.85501 7.26609Z"
          fill="#1C1C1C" />
      </svg>
    </button>
    <div class="ui-title">Write Answer</div>
    <button
      class="ui-close"
      on:click={() => {
        dispatch('close');
      }}
      ><svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.93932 8.50003L2.00049 13.4386L3.06112 14.4993L8 9.56066L12.9389 14.4993L13.9995 13.4386L9.06069 8.50003L13.9995 3.56142L12.9389 2.50073L8 7.43939L3.06112 2.50073L2.00049 3.56142L6.93932 8.50003Z"
          fill="#1C1C1C" />
      </svg>
    </button>
  </div>

  <div class="answer-form">
    <div class="selected-question-container">
      <div class="selected-question">{question}</div>
      <div
        class="back-btn"
        on:click={() => {
          selectedQuestion.answer = '';
          dispatch('newQuestion');
        }}>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.9398 1.44656C12.3406 0.847374 11.3682 0.850457 10.7729 1.45342L1.21631 11.1321L1 11.3512V11.6591V14.2508V15.0008H1.75H4.34171H4.64958L4.86865 14.7845L14.5474 5.22801C15.1504 4.63266 15.1535 3.66027 14.5543 3.0611L12.9398 1.44656ZM11.8402 2.50733C11.8509 2.49651 11.8684 2.49645 11.8791 2.5072L13.4936 4.12175C13.5044 4.1325 13.5043 4.14995 13.4935 4.16063L12.4291 5.21158L10.7893 3.57174L11.8402 2.50733ZM9.73535 4.63913L11.3617 6.2655L4.03383 13.5008H2.5V11.967L9.73535 4.63913Z"
            fill="#717171" />
        </svg>
      </div>
    </div>
    <Textarea
      focus={true}
      name="answer"
      autogrow={true}
      maxlength="150"
      showCharCount={true}
      rows={2}
      bind:value={selectedQuestion.answer}
      placeholder="Write your answer"
      on:keydown={(e) => {
        if (e.detail.event.code === 'Enter') {
          dispatch('submit', {
            id: selectedQuestion.id,
            answer: selectedQuestion.answer,
          });
          selectedQuestion.answer = '';
        }
      }} />
  </div>
  <div class="finished-btn">
    <Button
      disabled={!selectedQuestion.answer}
      colorScheme="black"
      style="padding-left: 40px; padding-right: 40px; width: auto; margin: 0;"
      text={'Continue'}
      on:click={() => {
        dispatch('submit', {
          id: selectedQuestion.id,
          answer: selectedQuestion.answer,
        });
        selectedQuestion.answer = '';
      }} />
  </div>
</div>
